export const getters = {
  getUserArticles: state => state.articles,
  getProps: state => state.defaultProps,
  getIcon: () => 'pulse'
};
